import { computed } from 'vue'

import { useI18nRoute } from '@/composables/useI18nRoute'

const FORM_COMPONENT_SELECTOR = '[data-component="form"]'

export function useHomeFormCtaTarget() {
  const { localizedPath } = useI18nRoute()

  const homePath = computed(() => localizedPath('home'))
  const targetEl = computed(() => FORM_COMPONENT_SELECTOR)

  return {
    homePath,
    targetEl,
  }
}
